import "./LoadingScreen.scss";

const runningImageSrc = `${process.env.PUBLIC_URL}/tecro-running.png`;

const LoadingScreen = () => {
  return (
    <main className="loading-screen" aria-busy="true" aria-live="polite">
      <div className="loading-screen__glow loading-screen__glow--one" />
      <div className="loading-screen__glow loading-screen__glow--two" />

      <div className="loading-screen__content" role="status">
        <div className="loading-screen__stage" aria-hidden="true">
          <span className="loading-screen__speed-line loading-screen__speed-line--one" />
          <span className="loading-screen__speed-line loading-screen__speed-line--two" />
          <span className="loading-screen__speed-line loading-screen__speed-line--three" />
          <span className="loading-screen__pulse" />
          <div className="loading-screen__runner">
            <img
              src={runningImageSrc}
              alt=""
              className="loading-screen__logo"
            />
          </div>
        </div>

        <div className="loading-screen__eyebrow">Technology Reply</div>
        <h1 className="loading-screen__title">HolidayApp</h1>
        <p className="loading-screen__message">Getting things ready&hellip;</p>

        <div className="loading-screen__track" aria-hidden="true">
          <span className="loading-screen__progress" />
        </div>
      </div>
    </main>
  );
};

export default LoadingScreen;
